import React, { Component, PropTypes } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom'
import { openExtraModal,closeExtraModal,openTermsModal } from '../../actions/modals.js';
import { removeExtra, upsell_time_limit, upsell_editor_level } from '../../actions/paper.js';
import Extras from './Extras.js';
import calculatePrice from '../../util/calculatePrice';
import PaypalExpressBtn from 'react-paypal-express-checkout';
import Terms from './Terms.js';
import { Field, reduxForm } from 'redux-form';

const fields = [ 'avatar' ];

const RegisterForm = props => {
  const { fields: { avatar }, handleSubmit, pristine, load, reset, submitting } = props;
  return (
    <div>
      <div className="register-form-container">
        <form onSubmit={handleSubmit}>
          <Field className="form-field" name="email" component="input" type="text"/>
          <br/>
          <Field className="form-field" name="firstName" placeholder="First Name" component="input" type="text"/>
          <br/>
          <Field className="form-field" name="lastName" placeholder="Last Name" component="input" type="text"/>
          <br/>
          <Field className="form-field" name="phone" placeholder="phone number" component="input" type="text"/>
          <br/>
          <div>
            <button type="submit" className="register-button"> Register </button>
          </div>
        </form>
      </div>
    </div>
  )
}

RegisterForm.propTypes = {
  fields: PropTypes.object.isRequired,
  load: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired
}

export default reduxForm({
  form: 'register-form-container',
  fields,
  enableReinitialize: true
})(RegisterForm);



// WEBPACK FOOTER //
// ./src/components/steps/registerform.js